import ImageQuestion, { ImageQuestionProps } from "./ImageQuestion";
import { ImageQuestionWrap } from "./styles";

export { ImageQuestionProps, ImageQuestionWrap };
export default ImageQuestion;
